import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {StatusModalComponent} from '../../../../../modals/status-modal/status-modal.component';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {Subject} from 'rxjs';
import {FormGroup, FormControl, FormArray, FormBuilder} from '@angular/forms';
import {UtilService} from '../../../../../../shared/_services/util.service';
import {HcaUserManagementService} from '../../../../../../shared/_services/hca-user-management.service';
import {ErrorSuccessMsgComponent} from '../../../../../modals/error-success-msg/error-success-msg.component';

@Component({
  selector: 'app-members-list',
  templateUrl: './pending-items.component.html',
  styleUrls: ['./pending-items-component.scss']
})

export class PendingItemsListComponent implements OnInit {
  searchForm: any;
  private _searchTerm: FormControl;
  totalCount: any;
  memberRulesList: any;
  statusModal: BsModalRef;
  transactionList: any[] = [];
  p = 0;
  size = 10;
  membersForm: FormGroup;
  actionSvg = 'assets/images/action-inactive.svg';
  private unsubscribe: Subject<void> = new Subject<void>();
  brandsList: any[] = [];
  selectedBrands: any[] = [];
  brandHotels: any[] = [];
  loadingMembers: boolean;

  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private utilService: UtilService,
    private hcaMemberService: HcaMemberService,
    private hcaUserManagementService: HcaUserManagementService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action === 'action1') {
          if (this.statusModal.content.srcObject.type === 'member-list') {
            if (this.statusModal.content.srcObject.status) {
              let statusId: any;
              let status: string;
              console.log(this.statusModal.content.srcObject.id);
              if (this.statusModal.content.srcObject.status === 'Activate') {
                statusId = 1;
                status = 'Active';
              } else if (this.statusModal.content.srcObject.status === 'Inactive') {
                statusId = 0;
                status = 'Inactive';
              } else {
                statusId = 7;
              }
              this.hcaMemberService
                .activateOrDeactivateMembers(
                  this.statusModal.content.srcObject.id, statusId, this.statusModal.content.srcObject.duplicatedEmailId)
                .subscribe(
                  (res) => {
                  if (res.error === 0) {
                    // this.getPendingItemsList();
                    this.getMemberByFilter(this.membersForm.value, this.p > 0 ? this.p - 1 : this.p, this.p);
                  }
                  if (this.statusModal.content.srcObject.status === 'Duplicated') {
                    this.openSuccessErrorMsg('Success', 'Email duplicated successfully');
                  }
                }, error => {
                  console.error(error);
                  if (this.statusModal.content.srcObject.status === 'Duplicated') {
                    this.openSuccessErrorMsg(
                      'Error', error && error.message ? error.message : 'Email duplicated successfully');
                  }
                });
            }
          } else if (this.statusModal.content.srcObject.type == 'email-list') {
            if (this.statusModal.content.srcObject.status) {
              console.log(this.statusModal.content.srcObject.id);
              if (this.statusModal.content.srcObject.status === 'Welcome') {
                this.sendEmail(this.statusModal.content.srcObject.id, 'Welcome');
                console.log('Welcome members');
              } else {
                this.sendEmail(this.statusModal.content.srcObject.id, 'Verify');
                console.log('verify members');
              }
            }
          }
        }
      }
    });
  }


  blockSpecialChars(event) {
    var regex = new RegExp('^[a-zA-Z0-9]+$');
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    // var yourInput = event.key;
    // let re1 = /[#%&_+\\{\}\[\]\\\/]/gi;
    // let re = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
    // var isSplChar = re.test(yourInput);
    // if(isSplChar)
    // {
    //   event.preventDefault();
    //   return false;
    // }
  }

  getPendingItemsList(term?) {
    this.loadingMembers = true;
    this.hcaMemberService.getConciergePendingItemsList(this.p > 0 ? this.p - 1 : this.p, term ? term : '').subscribe(res => {
      this.loadingMembers = false;
      console.log(res.message)
      if ( res.message == "Success") {
        this.transactionList = res.responseObj.items;
        console.log(this.transactionList)
        this.totalCount = res.responseObj.total_records;
        console.log(this.totalCount)
      }
    });
  }

  sendEmail(id, type) {
    this.hcaMemberService.sendEmail(id, type).subscribe(res => {
      if (res) {
        console.log(res);
      }
    });
  }

  pageChanged($event) {
    const page = $event - 1;
    const isFilter = this.hasNull(
      this.membersForm.value, ['statusId', 'origins', 'isActionRequired', 'brands', 'startDate', 'endDate']);
    
    if (isFilter) {
      this.getMemberByFilter(this.membersForm.value, page, $event);
    } else {
      this.hcaMemberService.getConciergeMemberList(page, this.searchForm.get('searchTerm').value).subscribe(res => {
        if (res.message == "Success") {
          this.transactionList = res.responseObj.members;
          this.totalCount = res.responseObj.total_records;
          this.p = $event;
        }
      });
    }
  }

  hasNull(target, keys) {
    for (const member in target) {
      for (let i = 0; i < keys.length; i++) {
        if (member === keys[i]) {
          if ((member === 'statusId' && target[member] !== '-1') || (
            member === 'brands' && target[member] && target[member].length) || (
              member === 'origins' && target[member] && target[member].length) || (
                member !== 'statusId' && member !== 'brands' && member !== 'origins' && !target[member])) {
            return true;
          }
        }
      }
    }
    return false;
  }

  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('members-filter').style.display === 'block') {
      document.getElementById('members-filter').style.display = 'none';
    } else {
      document.getElementById('members-filter').style.display = 'block';
    }
  }

  openModalActivateDeactivate(id, mode, member) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'Active') {
      message = 'Are you sure you want to deactivate member?';
      title = 'Deactivate Member';
      action1 = 'Deactivate';
      style = 'inactive';
      status = 'Inactive';
    }
    if (mode === 'Inactive') {
      message = 'Are you sure you want to activate member?';
      title = 'Activate Member';
      action1 = 'Activate';
      style = 'active';
      status = 'Activate';
    } else if (mode === 'duplicated') {
      message = 'Please enter email id or card code.';
      title = 'Duplicated';
      action1 = 'Yes';
      // style = "active";
      status = 'Duplicated';
    }

    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'member-list',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: mode === 'duplicated' ? 'No' : 'Cancel',
      action: '',
      style: style,
      // form: promo
    };
  }

  openModalEmail(id, mode, email) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'welcome') {
      message = 'Are you sure you want to send welcome email?';
      title = 'Welcome Email';
      action1 = 'Yes';
      style = 'active';
      status = 'Welcome';
    } else if (mode === 'verify') {
      message = 'Are you sure you want to send verification email?';
      title = 'Verification Email';
      action1 = 'Yes';
      style = 'active';
      status = 'Verify';
    }
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'email-list',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'No',
      action: '',
      style: style,
    };
  }

  // open success or error message display modal
  openSuccessErrorMsg(mode, msg) {
    this.statusModal = this.modalService.show(ErrorSuccessMsgComponent, {class: 'errorSuccess-modal'});
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'Success') {
      message = msg;
      title = '';
      action1 = '';
      style = 'activate';
      status = '';
    } else if (mode === 'Error') {
      message = msg;
      title = '';
      action1 = '';
      style = 'deactivate';
      status = '';
    }
    this.statusModal.content.srcObject = {
      mode: 'duplicateMsg',
      type: 'member-list',
      message: message,
      action1: action1,
      action2: 'OK',
      action: '',
      style: style
    };
  }

  getHotelsList() {
    const brandIds = this.utilService.cleanArray(this.selectedBrands);
    const formArray = this.membersForm.controls['hotelIds'] as FormArray;
    this.clearFormArray(formArray);
    this.hcaUserManagementService.getHotelsByBrand(brandIds).subscribe((res: any) => {
      console.log('res', res);
      if (res.error === 0) {
        this.brandHotels = res.responseObj;
        console.log(this.brandHotels);
        if (this.brandHotels) {
          const noneHotel = {
            banner: null,
            bannerFile: null,
            brandId: null,
            contactEmail: null,
            contactName: null,
            contactNumber: null,
            contactSkypeId: null,
            description: null,
            hasPremiumServices: null,
            hotelCode: null,
            hotelId: -1,
            hotelName: 'None',
            isFromWizard: null,
            location: null,
            seasonsList: null,
            status: null,
            statusId: null,
            tags: null,
            totalRooms: null,
            voucherEmailId: null,
            website: null
          };
          this.brandHotels.push(noneHotel);
          this.brandHotels.forEach(element => {
            this.checkSelected(true, 'hotelIds', 'hotelId', element.hotelId);
          });
        }
      } else {
        this.brandHotels = [];
      }
    }, err => {
      this.brandHotels = [];
    });
  }

  getMemberRules() {
    this.hcaMemberService.getMemberRules().subscribe(res => {
      if (res.error === 0) {
        this.memberRulesList = res.responseObj;
        this.brandsList = res.responseObj.brands;
        this.selectedBrands = this.utilService.cleanArray(this.brandsList.map(brand => {
          if (brand.checked) {
            // return brand.brandId;
            this.checkSelection(brand.checked, this.membersForm, brand, brand.brandId);
          }
        }));
        this.getHotelsList();
      }
    });
  }

  checkSelection(isChecked?: boolean, control?, type?, id?) {
    const formControl = <FormArray>this[control];
    if (isChecked) {
      if (type === 'brand') {
        formControl.controls['brands'].push(new FormControl(id));
        this.selectedBrands = formControl.controls['brands'].value;
        this.getHotelsList();
      } else if (type === 'origin') {
        formControl.controls['origins'].push(new FormControl(id));
      }
    } else {
      if (type === 'brand') {
        const index = formControl.controls['brands'].controls.findIndex(x => x.value === id);
        formControl.controls['brands'].removeAt(index);
        this.selectedBrands = formControl.controls['brands'].value;
        this.getHotelsList();
      } else if (type === 'origin') {
        const index = formControl.controls['origins'].controls.findIndex(x => x.value === id);
        formControl.controls['origins'].removeAt(index);
      }
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  checkSelected(isChecked: boolean, controlName, valueType, value) {
    const formArray = this.membersForm.controls[controlName] as FormArray;
    if (isChecked) {

      formArray.push(new FormControl(value));
    } else {
      const index = formArray.controls.findIndex(x => x.value === value);
      if (index > -1) {
        formArray.removeAt(index);
      }
      if (formArray.value.indexOf(0) > -1) {
        if (this.brandHotels.length !== formArray.value.length - 1) {
          const idx = formArray.controls.findIndex(x => x.value === 0);
          if (idx > -1) {
            formArray.removeAt(idx);
          }
        }
      }
    }
  }

  getMemberByFilter(value, page, event?) {
    this.hcaMemberService.getConciergueMemberListFromFilter(
      value, page, this.searchForm.get('searchTerm').value).subscribe(res => {
      if (res.message === 'Success') {
        if (res.responseObj && res.responseObj.members) {
          this.transactionList = res.responseObj.members;
          this.totalCount = res.responseObj.total_records;
          this.p = event;
        } else {
          this.transactionList = [];
          this.totalCount = 0;
        }
      }
    });
  }

  clearDate() {
    if (this.membersForm.get('range').value) {
      this.membersForm.get('range').setValue(null);
      this.membersForm.get('startDate').setValue(null);
      this.membersForm.get('endDate').setValue(null);
    }
  }

  searchTerm() {
    this.getMemberByFilter(this.membersForm.value, this.p > 0 ? this.p - 1 : this.p, this.p);
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  ngOnInit() {
    this.getMemberRules();
    const hotels = this.fb.array([]);
    this.membersForm = new FormGroup({
      statusId: new FormControl('-1'),
      origins: new FormArray([]),
      isActionRequired: new FormControl(null),
      brands: new FormArray([]),
      hotelIds: hotels,
      range: new FormControl(null),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
    });
    this.membersForm.controls['range'].valueChanges.debounceTime(400).subscribe(value => {
      if (!value || (value && !value.length)) {
        this.membersForm.get('startDate').setValue(null);
        this.membersForm.get('endDate').setValue(null);
      } else {
        this.membersForm.get('startDate').setValue(value[0] ? this.utilService.formatDate(value[0]) : null);
        this.membersForm.get('endDate').setValue(value[1] ? this.utilService.formatDate(value[1]) : null);
      }
    }, err => {
      console.error('date', err);
    });
    this.membersForm.valueChanges.debounceTime(600).subscribe(value => {
      this.getMemberByFilter(value, 0, 0);
    });
    this.getPendingItemsList('');
    this.searchForm = new FormGroup({
      searchTerm: new FormControl('')
    });
    this._searchTerm = this.searchForm.get('searchTerm');
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/concierge/members-management/pending-items-list/pending-items.component.ts